<template>

  <div class="inventory-cost-recalc-page">
     <KTCodePreview
      > <template #title
        >
        <div class="ccr-head-title w-100">

          <div class="d-flex flex-wrap align-items-center">

            <h3 class="card-label mb-0 font-weight-bolder mr-2">Giá vốn theo kỳ</h3>
             <template v-if="runDetail"
              > <code class="ccr-short-id">{{ compactRunId }}</code
              > <b-badge
                pill
                :variant="workflowHeaderBadgeVariant"
                class="ccr-status-pill ml-2"
                >{{ workflowHeaderBadgeLabel }}</b-badge
              > </template
            >
          </div>

          <p
            v-if="runDetailMetaLine"
            class="text-muted small mb-0 mt-2"
          >
            {{ runDetailMetaLine }}
          </p>

        </div>
         </template
      > <template v-slot:preview
        > <!-- Giới thiệu -->
        <div
          v-if="!runDetail"
          class="mb-3"
        >

          <p class="ccr-lead text-muted small mb-2">
             Tái tính giá vốn theo kỳ <strong>theo doanh nghiệp (công ty)</strong> — ghi đơn giá vốn
            trên hóa đơn bán trong phạm vi kỳ đã chọn.
          </p>

          <div class="ccr-workflow border rounded-sm bg-white px-3 py-2 mb-3">

            <div class="d-flex flex-wrap align-items-baseline">
               <span class="ccr-kicker mr-2">Quy trình</span>
              <div class="ccr-workflow-line small text-dark">
                 <span>Tạo lô</span> <span
                  class="ccr-step-sep text-muted"
                  aria-hidden="true"
                  >→</span
                > <span>Chạy tính</span> <span
                  class="ccr-step-sep text-muted"
                  aria-hidden="true"
                  >→</span
                > <span>Preview dòng</span> <span
                  class="ccr-step-sep text-muted"
                  aria-hidden="true"
                  >→</span
                > <span>Áp dụng <code class="ccr-code">BillItem.originalPrice</code></span
                >
              </div>

            </div>

            <p class="small text-muted mb-0 mt-1">
               Tính toán có thể xử lý bất đồng bộ (poll trạng thái). Quyền: xem / tính / áp dụng.
            </p>

          </div>

        </div>
         <!-- Tạo lô --> <b-card
          class="ccr-card mb-3"
          header="Thông tin lô"
          header-tag="div"
          header-bg-variant="light"
          header-class="ccr-card-header py-2 px-3"
          > <b-row class="form-row"
            > <b-col
              cols="12"
              lg="4"
              > <b-form-group
                label="Công ty (*)"
                label-for="cc-company"
                label-class="ccr-label"
                :state="companySelectState"
                invalid-feedback="Vui lòng chọn công ty"
                class="mb-2"
                > <b-form-select
                  id="cc-company"
                  class="select-style"
                  v-model="form.companyId"
                  :options="companies"
                  value-field="id"
                  text-field="name"
                  size="sm"
                  :disabled="busy || Boolean(runDetail)"
                  :state="companySelectState"
                  > <template #first
                    > <b-form-select-option
                      :value="null"
                      disabled
                      >Chọn công ty</b-form-select-option
                    > </template
                  > </b-form-select
                > </b-form-group
              > </b-col
            > <b-col
              cols="12"
              sm="6"
              lg="4"
              > <b-form-group
                label="Từ ngày (*)"
                label-for="cc-from"
                label-class="ccr-label"
                :state="periodStartState"
                invalid-feedback="Bắt buộc"
                class="mb-2"
                > <b-form-input
                  id="cc-from"
                  v-model="form.periodStart"
                  type="date"
                  size="sm"
                  :disabled="busy || Boolean(runDetail)"
                  :state="periodStartState"
                /> </b-form-group
              > </b-col
            > <b-col
              cols="12"
              sm="6"
              lg="4"
              > <b-form-group
                label="Đến ngày (*)"
                label-for="cc-to"
                label-class="ccr-label"
                :state="periodEndState"
                invalid-feedback="Bắt buộc"
                class="mb-2"
                > <b-form-input
                  id="cc-to"
                  v-model="form.periodEnd"
                  type="date"
                  size="sm"
                  :disabled="busy || Boolean(runDetail)"
                  :state="periodEndState"
                /> </b-form-group
              > </b-col
            > </b-row
          >
          <div
            v-if="createFormShowErrors && periodOrderInvalid"
            class="text-danger small mb-2"
          >
             Đến ngày phải ≥ Từ ngày.
          </div>
           <b-row class="form-row"
            > <b-col
              cols="12"
              md="4"
              lg="4"
              > <b-form-group
                label="Phương pháp (*)"
                label-for="cc-method"
                label-class="ccr-label"
                :state="valuationSelectState"
                invalid-feedback="Vui lòng chọn phương pháp"
                class="mb-2"
                > <b-form-select
                  id="cc-method"
                  class="select-style"
                  v-model="form.valuationMethod"
                  :options="valuationOptions"
                  size="sm"
                  :disabled="busy || Boolean(runDetail)"
                  :state="valuationSelectState"
                /> </b-form-group
              > </b-col
            > <b-col
              cols="12"
              md="8"
              lg="8"
              > <b-form-group
                label="Ghi chú"
                label-for="cc-memo"
                label-class="ccr-label"
                class="mb-2"
                > <b-form-input
                  id="cc-memo"
                  v-model.trim="form.memo"
                  size="sm"
                  placeholder="Tuỳ chọn"
                  :disabled="busy || Boolean(runDetail)"
                /> </b-form-group
              > </b-col
            > </b-row
          >
          <div
            class="ccr-form-actions d-flex flex-wrap align-items-center justify-content-between border-top pt-3 mt-2"
          >
             <span class="small text-muted mb-2 mb-sm-0">(*) Trường bắt buộc</span> <b-button
              variant="primary"
              size="sm"
              :disabled="busy || !canCreate || Boolean(runDetail)"
              class="font-weight-bold"
              @click="createRun"
              > Tạo lô </b-button
            >
          </div>
           </b-card
        > <!-- Mở lô --> <b-card
          class="ccr-card mb-3"
          header="Tra cứu / tiếp tục lô"
          header-tag="div"
          header-bg-variant="light"
          header-class="ccr-card-header py-2 px-3"
          >
          <p
            v-if="!checkPermission('COST_RECALCULATION_VIEW')"
            class="small text-muted mb-3"
          >
             Cần quyền xem (COST_RECALCULATION_VIEW) để tải danh sách lô.
          </p>
           <template v-else-if="!Number(form.companyId)"
            >
            <p class="small text-muted mb-0">
              Chọn công ty ở biểu mẫu phía trên để xem danh sách lô.
            </p>
             </template
          > <template v-else
            > <b-row class="form-row align-items-end mb-3"
              > <b-col
                cols="12"
                md="4"
                class="mb-2 mb-md-0"
                > <label class="ccr-label d-block mb-1">Trạng thái</label> <b-form-select
                  v-model="runsListFilters.status"
                  class="select-style"
                  size="sm"
                  :options="runsListStatusFilterOptions"
                  value-field="value"
                  text-field="text"
                  :disabled="busy || runsListLoading"
                  @change="fetchRunsList(true)"
                /> </b-col
              > <b-col
                cols="12"
                md="3"
                class="mb-2 mb-md-0"
                > <label class="ccr-label d-block mb-1">Số dòng / trang</label> <b-form-select
                  v-model.number="runsListFilters.limit"
                  class="select-style"
                  size="sm"
                  :options="runsListLimitOptions"
                  :disabled="busy || runsListLoading"
                  @change="fetchRunsList(true)"
                /> </b-col
              > <b-col
                cols="12"
                md="5"
                class="d-flex flex-wrap align-items-end mb-2 mb-md-0"
                > <b-button
                  variant="outline-primary"
                  size="sm"
                  class="mr-2"
                  :disabled="busy || runsListLoading"
                  @click="fetchRunsList(true)"
                  > <i
                    class="fas fa-sync-alt mr-1"
                    aria-hidden="true"
                  ></i
                  >Làm mới danh sách </b-button
                > <b-button
                  variant="outline-secondary"
                  size="sm"
                  :disabled="busy"
                  @click="resetWorkflow"
                  > Làm việc lô mới </b-button
                > </b-col
              > </b-row
            >
            <div class="table-responsive">
               <b-table
                id="ccr-runs-table"
                :items="runsList"
                :fields="runListTableFields"
                :busy="runsListLoading"
                small
                striped
                hover
                bordered
                show-empty
                empty-text="Không có lô nào trong bộ lọc."
                tbody-class="ccr-runs-list-tbody"
                > <template #table-busy
                  >
                  <div class="text-center text-muted my-3">
                     <b-spinner
                      small
                      class="mr-2"
                    ></b-spinner
                    >Đang tải…
                  </div>
                   </template
                > <template #cell(runCode)="row"
                  > <strong class="text-dark">{{ row.item.runCode || '—' }}</strong
                  >
                  <div
                    v-if="row.item.id"
                    class="small text-muted font-monospace text-break"
                  >
                     {{ compactRunIdHint(row.item.id) }}
                  </div>
                   </template
                > <template #cell(periodStart)="row"
                  > <span class="small">{{ formatPeriodDate(row.item.periodStart) || '—' }}</span
                  > <span class="text-muted"> → </span> <span class="small">{{
                    formatPeriodDate(row.item.periodEnd) || '—'
                  }}</span
                  > </template
                > <template #cell(status)="row"
                  > <b-badge :variant="runStatusBadgeVariant(row.item.status)"
                    > {{ runStatusLabel(row.item.status) }} </b-badge
                  > </template
                > <template #cell(createdAt)="row"
                  > <span class="small">{{
                    formatDateTimeDdMmYyHhMm(row.item.createdAt) || '—'
                  }}</span
                  > </template
                > <template #cell(updatedAt)="row"
                  > <span class="small">{{
                    formatDateTimeDdMmYyHhMm(row.item.updatedAt) || '—'
                  }}</span
                  > </template
                > <template #cell(_actions)="row"
                  > <b-button
                    variant="primary"
                    size="sm"
                    :disabled="busy || !resolveRunListItemId(row.item)"
                    @click="openRunFromList(row.item)"
                    > Mở </b-button
                  > </template
                > </b-table
              >
            </div>

            <div
              v-if="runsListTotal > runsListLimitClamped"
              class="d-flex justify-content-center mt-3"
            >
               <b-pagination
                v-model="runsListPage"
                :total-rows="runsListTotal"
                :per-page="runsListLimitClamped"
                size="sm"
                align="center"
                class="mb-0 flex-wrap"
                @change="fetchRunsList(false)"
              />
            </div>

            <p class="small text-muted mt-2 mb-0">
               Tổng <strong>{{ runsListTotal }}</strong
              > lô · trang {{ runsListPage }} / {{ runsListTotalPages }}
            </p>
             </template
          >
          <hr class="my-4" />
           <button
            type="button"
            class="btn btn-link btn-sm px-0 mb-2"
            @click="showManualUuid = !showManualUuid"
          >
             {{ showManualUuid ? 'Ẩn' : 'Mở' }} tải lô theo UUID </button
          > <b-collapse v-model="showManualUuid"
            > <label
              for="cc-manual-run"
              class="ccr-label d-block mb-1"
              >Mã lô (UUID)</label
            > <b-input-group
              size="sm"
              class="ccr-uuid-group"
              > <b-form-input
                id="cc-manual-run"
                v-model.trim="manualRunId"
                placeholder="Dán UUID đầy đủ nếu cần"
                :disabled="busy"
              /> <b-input-group-append
                > <b-button
                  variant="outline-primary"
                  :disabled="busy || !manualRunId"
                  @click="loadManualRun"
                  > Tải lô </b-button
                > </b-input-group-append
              > </b-input-group
            > </b-collapse
          > </b-card
        > <!-- Không gian làm việc lô -->
        <div
          v-if="runDetail"
          class="ccr-workspace border rounded-sm bg-white px-3 px-md-4 py-3 mb-3"
        >

          <div class="d-flex flex-wrap align-items-center mb-3 pb-2 border-bottom ccr-toolbar">
             <b-button
              variant="outline-secondary"
              size="sm"
              class="ccr-tool-btn mb-1 mr-1"
              :disabled="busy || !runDetail || !linesPreviewEligible || linesLoading"
              v-if="checkPermission('COST_RECALCULATION_VIEW')"
              @click="fetchLines(true)"
              > <i
                class="fas fa-redo-alt mr-1"
                aria-hidden="true"
              ></i
              >Tải lại dòng </b-button
            > <b-button
              variant="outline-secondary"
              size="sm"
              class="ccr-tool-btn mb-1 mr-1"
              :disabled="busy || !runDetail"
              @click="refreshRunQuiet"
              > <i
                class="fas fa-sync-alt mr-1"
                aria-hidden="true"
              ></i
              >Làm mới trạng thái </b-button
            > <b-button
              variant="outline-primary"
              size="sm"
              class="ccr-tool-btn mb-1 mr-1"
              :disabled="busy || pollingCompute || !canComputeRun"
              @click="onCompute"
              v-if="checkPermission('COST_RECALCULATION_COMPUTE')"
              > <span v-if="pollingCompute && !pollingRecompute"
                ><b-spinner
                  small
                  class="mr-1"
                ></b-spinner></span
              > <i
                v-else
                class="fas fa-play mr-1"
                aria-hidden="true"
              ></i
              >Chạy tính </b-button
            > <b-button
              variant="outline-warning"
              size="sm"
              class="ccr-tool-btn mb-1 mr-1"
              :disabled="busy || pollingCompute || !canRecomputeRun"
              title="Xóa dòng preview cũ và tính lại (POST …/recompute)"
              @click="onRecompute"
              v-if="checkPermission('COST_RECALCULATION_COMPUTE')"
              > <span v-if="pollingRecompute"
                ><b-spinner
                  small
                  class="mr-1"
                ></b-spinner></span
              > <i
                v-else
                class="fas fa-redo-alt mr-1"
                aria-hidden="true"
              ></i
              >Tính lại </b-button
            > <b-button
              variant="success"
              size="sm"
              class="ccr-tool-btn mb-1 mr-1 font-weight-bold"
              :disabled="busy || pollingApply || !canApplyRun"
              @click="onApply"
              v-if="checkPermission('COST_RECALCULATION_APPLY')"
              > <span v-if="pollingApply"
                ><b-spinner
                  small
                  class="mr-1"
                ></b-spinner></span
              > <i
                v-else
                class="fas fa-check mr-1"
                aria-hidden="true"
              ></i
              >Áp dụng </b-button
            > <b-dropdown
              variant="outline-secondary"
              size="sm"
              class="mb-1 mr-1"
              right
              no-caret
              > <template #button-content><i class="fas fa-ellipsis-h"></i></template>
              <b-dropdown-item @click.prevent="copyRunId"
                > <i class="far fa-copy mr-2"></i>Copy UUID lô </b-dropdown-item
              > </b-dropdown
            >
          </div>

          <ol
            class="ccr-stepper list-unstyled d-flex flex-wrap justify-content-between mb-4 px-xl-2"
          >

            <li
              v-for="(lbl, idx) in stepperStepLabels"
              :key="'st' + idx"
              class="ccr-stepper-item text-center"
              :class="stepperItemClass(idx + 1)"
            >

              <div class="ccr-stepper-circle mx-auto mb-1">
                 <i
                  v-if="stepperShowsCheck(idx + 1)"
                  class="fas fa-check"
                  aria-hidden="true"
                ></i
                > <span v-else>{{ idx + 1 }}</span
                >
              </div>

              <div class="small ccr-stepper-label">{{ lbl }}</div>

            </li>

          </ol>
           <b-row class="mb-3"
            > <b-col
              cols="6"
              md="3"
              class="mb-2 mb-md-0"
              >
              <div class="ccr-kpi-card h-100 border rounded-sm p-3">

                <div class="small text-muted mb-1 text-uppercase ccr-kpi-k">Tổng dòng</div>

                <div class="h6 mb-0 font-weight-bold text-dark">
                  {{ formatInteger(kpiTotalLines) }}
                </div>

              </div>
               </b-col
            > <b-col
              cols="6"
              md="3"
              class="mb-2 mb-md-0"
              >
              <div class="ccr-kpi-card h-100 border rounded-sm p-3">

                <div class="small text-muted mb-1 text-uppercase ccr-kpi-k">Giá trị tồn cuối</div>

                <div class="h6 mb-0 font-weight-bold text-dark">
                  {{ formatMoney(kpiClosingInventoryValue) }} đ
                </div>

              </div>
               </b-col
            > <b-col
              cols="6"
              md="3"
              class="mb-2 mb-md-0"
              >
              <div class="ccr-kpi-card h-100 border rounded-sm p-3">

                <div class="small text-muted mb-1 text-uppercase ccr-kpi-k">
                  Chênh lệch ĐGV (ước)
                </div>

                <div
                  class="h6 mb-0 font-weight-bold"
                  :class="
                    kpiMovementPositive
                      ? 'text-success'
                      : kpiMovementPositive === false
                        ? 'text-danger'
                        : 'text-dark'
                  "
                >
                   {{ kpiMovementFormatted }}
                </div>

              </div>
               </b-col
            > <b-col
              cols="6"
              md="3"
              class="mb-2 mb-md-0"
              >
              <div class="ccr-kpi-card h-100 border rounded-sm p-3">

                <div class="small text-muted mb-1 text-uppercase ccr-kpi-k">Cảnh báo</div>

                <div
                  class="h5 mb-0 font-weight-bold"
                  :class="kpiWarningCount > 0 ? 'text-warning' : 'text-dark'"
                >
                   {{ kpiWarningCount }}
                </div>

              </div>
               </b-col
            > </b-row
          > <b-collapse
            :visible="collapseMetaOpen"
            class="mb-2"
            >
            <dl class="row mb-0 ccr-dl small border rounded-sm p-3 bg-light">

              <dt class="col-sm-4 col-md-2">UUID</dt>

              <dd class="col-sm-8 col-md-10">
                 <code class="small">{{ runDetail.id }}</code
                >
              </dd>
               <template v-if="runDetail.sequence != null"
                >
                <dt class="col-sm-4 col-md-2">Bước</dt>

                <dd class="col-sm-8 col-md-4">{{ runDetail.sequence }}</dd>
                 </template
              > <template v-if="runDetail.memo"
                >
                <dt class="col-sm-4 col-md-2">Ghi chú</dt>

                <dd class="col-sm-8 col-md-10">{{ runDetail.memo }}</dd>
                 </template
              >
            </dl>
             </b-collapse
          >
          <div class="mb-3">
             <b-button
              variant="link"
              size="sm"
              class="p-0"
              @click="collapseMetaOpen = !collapseMetaOpen"
              > {{ collapseMetaOpen ? 'Ẩn' : 'Hiện' }} thông tin chi tiết lô </b-button
            >
          </div>
           <b-alert
            :show="Boolean(processHint)"
            variant="light"
            class="small mb-0 border"
            > {{ processHint }} </b-alert
          >
        </div>
         <!-- Bảng preview --> <b-card
          v-if="runDetail && linesPreviewEligible"
          class="ccr-card"
          header-bg-variant="light"
          header-class="ccr-card-header ccr-table-card-head py-2 px-3"
          > <template #header
            >
            <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
               <span class="font-weight-bold">Kết quả chi tiết (preview)</span> <b-button
                variant="outline-secondary"
                size="sm"
                :disabled="busy || linesLoading || linesExporting || !lines.length"
                @click="exportPreviewCsv"
                > <span v-if="linesExporting"
                  ><b-spinner
                    small
                    class="mr-1"
                  ></b-spinner></span
                > <i
                  v-else
                  class="fas fa-file-download mr-1"
                  aria-hidden="true"
                ></i
                >Xuất Excel (CSV) </b-button
              >
            </div>
             </template
          > <b-row
            v-if="checkPermission('COST_RECALCULATION_VIEW')"
            class="form-row align-items-end mb-3"
            > <b-col
              cols="12"
              md="5"
              class="mb-2 mb-md-0"
              > <label
                class="ccr-label d-block mb-1"
                for="ccr-lines-q"
                >Tìm SP (tên, mã, barcode)</label
              > <b-form-input
                id="ccr-lines-q"
                v-model.trim="linesFilters.search"
                type="search"
                size="sm"
                autocomplete="off"
                placeholder="Gõ và chờ (~0,5s) hoặc Enter"
                :disabled="busy || linesLoading"
                @keydown.enter.prevent="flushLinesSearchDebounce(true)"
                @input="debouncedFetchLines"
              /> </b-col
            > <b-col
              cols="12"
              md="4"
              class="mb-2 mb-md-0"
              > <label
                class="ccr-label d-block mb-1"
                for="ccr-lines-dim"
                >Loại dòng tồn</label
              > <b-form-select
                id="ccr-lines-dim"
                v-model="linesFilters.inventoryDimension"
                class="select-style"
                size="sm"
                :options="linesDimensionFilterOptions"
                value-field="value"
                text-field="text"
                :disabled="busy || linesLoading"
                @change="onLinesDimensionFilterChange"
              /> </b-col
            > <b-col
              cols="12"
              md="3"
              > <b-button
                variant="outline-primary"
                size="sm"
                class="mr-2"
                :disabled="busy || linesLoading"
                @click="flushLinesSearchDebounce(true)"
                > Lọc ngay </b-button
              > <b-button
                variant="outline-secondary"
                size="sm"
                :disabled="busy || linesLoading"
                @click="clearLinesFiltersAndRefetch"
                > Xoá lọc </b-button
              > </b-col
            > </b-row
          > <b-spinner
            v-if="linesLoading"
            class="mb-2"
            small
          />
          <div class="table-responsive ccr-table-wrap">
             <b-table
              v-if="!linesLoading"
              :items="displayCostRecalcLines"
              :fields="lineFields"
              :tbody-tr-class="costRecalcRowClass"
              small
              striped
              hover
              bordered
              show-empty
              empty-text="Không có dòng — thử đổi bộ lọc hoặc xoá lọc."
              class="cost-recalc-lines-table mb-0"
              > <template #cell(productDisplay)="row"
                >
                <div v-if="row.item._ccrRowKind === 'parent'">
                   <ProductCommonInfo
                    v-if="row.item.productId != null"
                    :product="productCommonInfoFromCostLine(row.item)"
                  />
                  <div
                    v-else
                    class="small font-weight-bold text-dark"
                  >
                    {{ productCodeLine(row.item) }}
                  </div>

                  <div
                    v-if="row.item._ccrChildImeiCount > 0"
                    class="small text-muted mt-1"
                  >
                     {{ row.item._ccrChildImeiCount }} IMEI · chi tiết bên dưới
                  </div>

                </div>

                <div
                  v-else
                  class="ccr-imei-child-cell pl-3 ml-2 border-left border-primary"
                >

                  <div class="text-muted small mb-0">IMEI</div>

                  <div class="font-weight-bold text-monospace small text-break">
                     {{ row.item.imeiNoSnapshot || '—' }}
                  </div>

                </div>
                 </template
              > <template #cell(computedUnitCost)="row">{{
                formatMoney(row.item.computedUnitCost)
              }}</template
              > <template #cell(openingUnitCost)="row">{{
                formatMoney(row.item.openingUnitCost)
              }}</template
              > <template #cell(openingQty)="row">{{ formatQty(row.item.openingQty) }}</template
              > <template #cell(periodReceiptQty)="row">{{
                formatQty(row.item.periodReceiptQty)
              }}</template
              > <template #cell(periodIssueQty)="row">{{
                formatQty(row.item.periodIssueQty)
              }}</template
              > <template #cell(closingQty)="row">{{ formatQty(row.item.closingQty) }}</template
              > <template #cell(closingUnitCost)="row">{{
                formatMoney(row.item.closingUnitCost)
              }}</template
              > </b-table
            >
          </div>
          <div class="ccr-lines-toolbar">

            <div class="ccr-lines-toolbar__left">
               <span class="ccr-lines-toolbar__total"
                ><span class="ccr-lines-toolbar__total-label">Tổng số:</span>
                <span class="ccr-lines-toolbar__total-value"
                  >{{ formatInteger(linesTotal) }}</span
                >
                <span class="ccr-lines-toolbar__total-label">dòng</span></span
              >
            </div>

            <div class="ccr-lines-toolbar__right">
               <BillRowsPerPageSelector
                v-model="linesLimit"
                :options="linesLimitOptions"
                :disabled="busy || linesLoading"
                @change="onLinesLimitChange"
              />
              <div
                v-show="linesTotalPages >= 2"
                class="ccr-lines-toolbar__divider"
              ></div>
               <b-pagination
                v-show="linesTotalPages >= 2"
                v-model="linesPage"
                :total-rows="linesTotal"
                :per-page="linesLimit"
                pills
                size="sm"
                align="right"
                class="ccr-lines-pagination mb-0"
                :disabled="busy || linesLoading"
                @change="onLinesPageChange"
              />
            </div>

          </div>
           </b-card
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
  import BillRowsPerPageSelector from '@/view/components/bills/BillRowsPerPageSelector.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import permissionMixin from '@/view/mixins/permission.mixin'
  import { getData } from '@/utils/saveDataToLocal'
  import { makeToastFaile, makeToastSuccess } from '@/utils/common'
  import ApiService from '@/core/services/api.service'
  import {
    COST_RECALC_INVENTORY_DIMENSION,
    COST_RECALC_RUN_STATUS,
    applyCostRecalculationRun,
    computeCostRecalculationRun,
    createCostRecalculationRun,
    getCostRecalculationLines,
    getCostRecalculationRun,
    inventoryDimensionLabel,
    listCostRecalculationRuns,
    pollCostRecalculationRun,
    recomputeCostRecalculationRun,
    runStatusLabel,
  } from '@/services/inventoryCostRecalculation.service'

  export default {
    name: 'ListInventoryCostRecalculation',
    components: { KTCodePreview, ProductCommonInfo, BillRowsPerPageSelector },
    mixins: [permissionMixin],
    data() {
      return {
        createFormShowErrors: false,
        busy: false,
        linesLoading: false,
        linesSearchDebounceId: null,
        linesFilters: {
          search: '',
          inventoryDimension: null,
        },
        pollingCompute: false,
        pollingRecompute: false,
        pollingApply: false,
        processHint: '',
        runFetchedAt: null,
        collapseMetaOpen: false,
        companies: [],
        form: {
          companyId: null,
          periodStart: '',
          periodEnd: '',
          valuationMethod: 1,
          memo: '',
        },
        valuationOptions: [{ value: 1, text: 'Moving average trong kỳ (1)' }],
        manualRunId: '',
        runDetail: null,
        lines: [],
        linesPage: 1,
        linesLimit: 100,
        linesTotal: 0,
        linesSummary: null,
        linesExporting: false,
        abortPoll: false,
        runsList: [],
        runsListTotal: 0,
        runsListLoading: false,
        runsListPage: 1,
        runsListFilters: {
          limit: 50,
          status: null,
        },
        showManualUuid: false,
        lineFields: [
          {
            key: 'productDisplay',
            label: 'Sản phẩm',
            thStyle: { minWidth: '240px' },
            tdClass: 'ccr-product-cell align-middle',
          },
          {
            key: 'openingQty',
            label: 'SL đầu',
            tdClass: 'text-right align-middle',
          },
          {
            key: 'openingUnitCost',
            label: 'ĐGV đầu',
            tdClass: 'text-right align-middle',
          },
          {
            key: 'periodReceiptQty',
            label: 'Nhập kỳ',
            tdClass: 'text-right align-middle',
          },
          {
            key: 'periodIssueQty',
            label: 'Xuất kỳ',
            tdClass: 'text-right align-middle',
          },
          {
            key: 'computedUnitCost',
            label: 'ĐGV tính',
            tdClass: 'text-right align-middle ccr-col-highlight',
            thClass: 'ccr-col-highlight',
          },
          {
            key: 'closingQty',
            label: 'SL cuối',
            tdClass: 'text-right align-middle',
          },
          {
            key: 'closingUnitCost',
            label: 'ĐGV cuối',
            tdClass: 'text-right align-middle',
          },
        ],
      }
    },
    computed: {
      periodOrderInvalid() {
        const s = this.form.periodStart
        const e = this.form.periodEnd
        if (!s || !e) return false
        return e < s
      },
      companySelectState() {
        if (this.runDetail) return null
        if (!this.createFormShowErrors) return null
        return Number(this.form.companyId) > 0
      },
      valuationSelectState() {
        if (this.runDetail) return null
        if (!this.createFormShowErrors) return null
        return Number(this.form.valuationMethod) > 0
      },
      periodStartState() {
        if (this.runDetail) return null
        if (!this.createFormShowErrors) return null
        if (!this.form.periodStart) return false
        if (this.periodOrderInvalid) return false
        return true
      },
      periodEndState() {
        if (this.runDetail) return null
        if (!this.createFormShowErrors) return null
        if (!this.form.periodEnd) return false
        if (this.periodOrderInvalid) return false
        return true
      },
      canCreate() {
        return (
          this.checkPermission('COST_RECALCULATION_COMPUTE') &&
          Number(this.form.companyId) > 0 &&
          Number(this.form.valuationMethod) > 0 &&
          this.form.periodStart &&
          this.form.periodEnd &&
          this.form.periodEnd >= this.form.periodStart
        )
      },
      canComputeRun() {
        return this.runDetail && Number(this.runDetail.status) === COST_RECALC_RUN_STATUS.DRAFT
      },
      canRecomputeRun() {
        return (
          this.runDetail &&
          Number(this.runDetail.status) === COST_RECALC_RUN_STATUS.COMPUTED &&
          !this.pollingCompute
        )
      },
      canApplyRun() {
        return (
          this.runDetail &&
          !this.pollingCompute &&
          Number(this.runDetail.status) === COST_RECALC_RUN_STATUS.COMPUTED
        )
      },
      resolvedCompanyLabel() {
        if (!this.runDetail || this.runDetail.companyId == null) return '—'
        const id = Number(this.runDetail.companyId)
        const c = this.companies.find((x) => Number(x.id) === id)
        return c && c.name ? c.name : String(this.runDetail.companyId)
      },
      runsListLimitClamped() {
        const n = Number(this.runsListFilters.limit)
        const base = Number.isFinite(n) ? n : 50
        return Math.min(100, Math.max(1, base))
      },
      /** Bảng danh sách lô */
      runListTableFields() {
        return [
          { key: 'runCode', label: 'Mã lô', thStyle: { minWidth: '100px' } },
          { key: 'periodStart', label: 'Kỳ', thStyle: { minWidth: '148px' } },
          {
            key: 'status',
            label: 'Trạng thái',
            tdClass: 'text-center align-middle',
            thStyle: { width: '120px' },
          },
          { key: 'createdAt', label: 'Tạo lúc', thStyle: { minWidth: '128px' } },
          { key: 'updatedAt', label: 'Cập nhật', thStyle: { minWidth: '128px' } },
          {
            key: '_actions',
            label: '',
            tdClass: 'text-right align-middle text-nowrap',
            thStyle: { width: '92px' },
          },
        ]
      },
      runsListLimitOptions() {
        return [
          { value: 25, text: '25 / trang' },
          { value: 50, text: '50 / trang' },
          { value: 100, text: '100 / trang' },
        ]
      },
      runsListStatusFilterOptions() {
        return [
          { value: null, text: '— Tất cả trạng thái —' },
          {
            value: COST_RECALC_RUN_STATUS.DRAFT,
            text: runStatusLabel(COST_RECALC_RUN_STATUS.DRAFT),
          },
          {
            value: COST_RECALC_RUN_STATUS.COMPUTED,
            text: runStatusLabel(COST_RECALC_RUN_STATUS.COMPUTED),
          },
          {
            value: COST_RECALC_RUN_STATUS.APPLIED,
            text: runStatusLabel(COST_RECALC_RUN_STATUS.APPLIED),
          },
          {
            value: COST_RECALC_RUN_STATUS.CANCELLED,
            text: runStatusLabel(COST_RECALC_RUN_STATUS.CANCELLED),
          },
        ]
      },
      compactRunId() {
        const id = (this.runDetail && this.runDetail.id) || ''
        if (!id || id.length < 9) return id
        return id.slice(0, 13)
      },
      valuationLabelDisplay() {
        const run = this.runDetail
        const m =
          run && run.valuationMethod != null
            ? Number(run.valuationMethod)
            : Number(this.form.valuationMethod)
        if (Number(m) === 1) return 'Bình quân gia quyền trong kỳ'
        const opt = this.valuationOptions.find((o) => Number(o.value) === m)
        return opt && opt.text ? opt.text.replace(/\s*\(\d+\)\s*$/, '') : String(m ?? '—')
      },
      workflowHeaderBadgeLabel() {
        if (!this.runDetail) return ''
        if (this.pollingApply) return 'Đang áp dụng…'
        if (this.pollingCompute || this.processHint) return 'Đang xử lý…'
        const s = Number(this.runDetail.status)
        switch (s) {
          case COST_RECALC_RUN_STATUS.DRAFT:
            return 'Nháp'
          case COST_RECALC_RUN_STATUS.COMPUTED:
            return 'Sẵn preview'
          case COST_RECALC_RUN_STATUS.APPLIED:
            return 'Đã áp dụng'
          case COST_RECALC_RUN_STATUS.CANCELLED:
            return 'Đã huỷ'
          default:
            return runStatusLabel(s)
        }
      },
      workflowHeaderBadgeVariant() {
        if (!this.runDetail) return 'secondary'
        if (this.pollingApply || this.pollingCompute || this.processHint) return 'info'
        const s = Number(this.runDetail.status)
        switch (s) {
          case COST_RECALC_RUN_STATUS.DRAFT:
            return 'secondary'
          case COST_RECALC_RUN_STATUS.COMPUTED:
            return 'warning'
          case COST_RECALC_RUN_STATUS.APPLIED:
            return 'success'
          case COST_RECALC_RUN_STATUS.CANCELLED:
            return 'dark'
          default:
            return 'light'
        }
      },
      runDetailMetaLine() {
        if (!this.runDetail) return ''
        const p0 = this.formatPeriodDate(this.runDetail.periodStart)
        const p1 = this.formatPeriodDate(this.runDetail.periodEnd)
        const parts = [
          `Kỳ: ${p0 || '—'} – ${p1 || '—'}`,
          `Phương pháp: ${this.valuationLabelDisplay}`,
          `Công ty: ${this.resolvedCompanyLabel}`,
        ]
        const isoUpd =
          this.runDetail.updatedAt ||
          this.runDetail.modifiedAt ||
          this.runDetail.completedAt ||
          this.runFetchedAtISO
        if (isoUpd) {
          parts.push(`Cập nhật: ${this.formatDateTimeDdMmYyHhMm(isoUpd)}`)
        }
        return parts.join(' · ')
      },
      runFetchedAtISO() {
        return this.runFetchedAt instanceof Date ? this.runFetchedAt.toISOString() : null
      },
      stepperStepLabels() {
        return ['Nháp', 'Đang tính', 'Sẵn preview', 'Đã áp dụng', 'Hoàn tất']
      },
      stepperActiveIndex() {
        if (!this.runDetail) return 0
        const s = Number(this.runDetail.status)
        if (s === COST_RECALC_RUN_STATUS.CANCELLED) return 5
        if (s === COST_RECALC_RUN_STATUS.APPLIED) return 5
        if (s === COST_RECALC_RUN_STATUS.COMPUTED) return 3
        if (this.pollingCompute || this.pollingApply || Boolean(this.processHint)) return 2
        if (s === COST_RECALC_RUN_STATUS.DRAFT) return 1
        return 1
      },
      kpiTotalLines() {
        if (this.linesSummary) return Number(this.linesSummary.totalLines) || 0
        return this.lines.length
      },
      kpiClosingInventoryValue() {
        if (this.linesSummary) return Number(this.linesSummary.closingInventoryValue) || 0
        return this.lines.reduce((acc, row) => {
          const q = Number(row.closingQty) || 0
          const u = Number(row.closingUnitCost) || 0
          return acc + q * u
        }, 0)
      },
      kpiUnitCostMovement() {
        if (this.linesSummary) return Number(this.linesSummary.unitCostMovement) || 0
        return this.lines.reduce((acc, row) => {
          const c = Number(row.computedUnitCost)
          const o = Number(row.openingUnitCost)
          if (!Number.isFinite(c) || !Number.isFinite(o)) return acc
          const q = Number(row.closingQty) || 0
          return acc + (c - o) * q
        }, 0)
      },
      kpiWarningCount() {
        if (this.linesSummary) return Number(this.linesSummary.warningCount) || 0
        return this.lines.filter((r) => {
          const c = r.computedUnitCost
          if (c == null || c === '') return true
          const n = Number(c)
          return Number.isFinite(n) && n < 0
        }).length
      },
      linesTotalPages() {
        const lim = Number(this.linesLimit) || 1
        return Math.max(1, Math.ceil((Number(this.linesTotal) || 0) / lim))
      },
      kpiMovementFormatted() {
        const raw = Number(this.kpiUnitCostMovement) || 0
        const abs = Math.abs(raw)
        const sign = raw > 0 ? '+' : raw < 0 ? '−' : ''
        let part
        if (abs >= 1e9) part = `${(abs / 1e9).toFixed(2)} B`
        else if (abs >= 1e6) part = `${(abs / 1e6).toFixed(1)} M`
        else if (abs >= 1e3) part = `${(abs / 1e3).toFixed(1)} K`
        else part = String(new Intl.NumberFormat('vn-VN').format(abs))
        return raw === 0 ? '—' : `${sign} ${part} đ`
      },
      kpiMovementPositive() {
        const raw = Number(this.kpiUnitCostMovement) || 0
        if (raw === 0) return null
        return raw >= 0
      },
      /** Hiển thị card preview khi đã có kết quả tính (kể cả khi lọc trả về 0 dòng). */
      linesPreviewEligible() {
        if (!this.runDetail) return false
        const s = Number(this.runDetail.status)
        return s === COST_RECALC_RUN_STATUS.COMPUTED || s === COST_RECALC_RUN_STATUS.APPLIED
      },
      linesDimensionFilterOptions() {
        return [
          { value: null, text: 'Tất cả (SP + IMEI)' },
          { value: COST_RECALC_INVENTORY_DIMENSION.PRODUCT, text: 'Chỉ cấp sản phẩm' },
          { value: COST_RECALC_INVENTORY_DIMENSION.IMEI, text: 'Chỉ dòng IMEI' },
        ]
      },
      linesLimitOptions() {
        return [
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 200, text: '200' },
          { value: 500, text: '500' },
        ]
      },
      runsListTotalPages() {
        const lim = this.runsListLimitClamped || 1
        return Math.max(1, Math.ceil((Number(this.runsListTotal) || 0) / lim))
      },
      /** Nhóm theo productId: cha = tổng/tổng quát sản phẩm; con = từng dòng IMEI */
      displayCostRecalcLines() {
        const lines = this.lines
        if (!Array.isArray(lines) || !lines.length) return []

        const IMEI = COST_RECALC_INVENTORY_DIMENSION.IMEI
        const groupOrder = []
        const groups = new Map()

        for (let idx = 0; idx < lines.length; idx += 1) {
          const line = lines[idx]
          const pid = line.productId != null ? String(line.productId) : `_idx_${idx}`
          if (!groups.has(pid)) {
            groups.set(pid, { productRows: [], imeiRows: [] })
            groupOrder.push(pid)
          }
          const bucket = groups.get(pid)
          if (Number(line.inventoryDimension) === IMEI) {
            bucket.imeiRows.push(line)
          } else {
            bucket.productRows.push(line)
          }
        }

        const out = []
        for (const pid of groupOrder) {
          const { productRows, imeiRows } = groups.get(pid)
          const imeiSorted = [...imeiRows].sort((a, b) =>
            String(a.imeiNoSnapshot || '').localeCompare(String(b.imeiNoSnapshot || '')),
          )

          if (productRows.length) {
            const parentBase =
              productRows.length === 1
                ? { ...productRows[0] }
                : this.mergeCostRecalcLines(productRows)
            out.push({
              ...parentBase,
              _ccrRowKind: 'parent',
              _ccrGroup: pid,
              _ccrChildImeiCount: imeiSorted.length,
            })
            imeiSorted.forEach((child) => {
              out.push({
                ...child,
                _ccrRowKind: 'imei-child',
                _ccrGroup: pid,
              })
            })
          } else if (imeiSorted.length) {
            const merged = this.mergeCostRecalcLines(imeiSorted)
            out.push({
              ...merged,
              imeiNoSnapshot: null,
              _ccrRowKind: 'parent',
              _ccrGroup: pid,
              _ccrChildImeiCount: imeiSorted.length,
            })
            imeiSorted.forEach((child) => {
              out.push({
                ...child,
                _ccrRowKind: 'imei-child',
                _ccrGroup: pid,
              })
            })
          }
        }

        return out
      },
    },
    watch: {
      'form.companyId': {
        handler() {
          if (this.checkPermission('COST_RECALCULATION_VIEW')) {
            this.fetchRunsList(true)
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kho hàng', route: '/inventory-receipt' },
        { title: 'Giá vốn theo kỳ' },
      ])
      const q = this.$route.query.runId || this.$route.query.id
      if (q) {
        this.manualRunId = q
        this.loadManualRun()
      }
      this.bootstrapOrg()
    },
    beforeDestroy() {
      this.abortPoll = true
      this.clearLinesSearchDebounceTimer()
    },
    methods: {
      runStatusLabel,
      inventoryDimensionLabel,
      formatMoney(v) {
        if (v == null || v === '') return '—'
        return new Intl.NumberFormat('vn-VN').format(Number(v))
      },
      formatInteger(v) {
        if (v == null || v === '') return '—'
        return new Intl.NumberFormat('vn-VN').format(Math.round(Number(v)))
      },
      formatQty(v) {
        if (v == null || v === '') return '—'
        return String(v)
      },
      mergeCostRecalcLines(rows) {
        if (!rows || !rows.length) return {}
        if (rows.length === 1) return { ...rows[0] }
        const sum = (k) => rows.reduce((a, r) => a + (Number(r[k]) || 0), 0)
        const wAvg = (wKey, cKey) => {
          let n = 0
          let d = 0
          rows.forEach((r) => {
            const w = Number(r[wKey])
            const c = Number(r[cKey])
            if (!Number.isFinite(w) || w <= 0 || !Number.isFinite(c)) return
            n += c * w
            d += w
          })
          if (d > 0) return n / d
          const first = rows.find((r) => r[cKey] != null && r[cKey] !== '')
          return first != null ? first[cKey] : null
        }
        const base = { ...rows[0] }
        base.openingQty = sum('openingQty')
        base.periodReceiptQty = sum('periodReceiptQty')
        base.periodIssueQty = sum('periodIssueQty')
        base.closingQty = sum('closingQty')
        base.openingUnitCost = wAvg('openingQty', 'openingUnitCost')
        base.computedUnitCost = wAvg('closingQty', 'computedUnitCost')
        base.closingUnitCost = wAvg('closingQty', 'closingUnitCost')
        return base
      },
      costRecalcRowClass(item, type) {
        if (type !== 'row' || !item) return ''
        return item._ccrRowKind === 'imei-child' ? 'ccr-tr-imei-child' : ''
      },
      productCommonInfoFromCostLine(line) {
        return {
          productId: line.productId,
          productImageUrl: line.productImageUrl || line.productImage || null,
          barCode: line.barCode || line.productBarCode || line.barcode || line.productBarcode || '',
          productCode: line.productCode || line.sku || '',
          productName: line.productName || line.name || '—',
        }
      },
      runStatusBadgeVariant(status) {
        switch (Number(status)) {
          case COST_RECALC_RUN_STATUS.DRAFT:
            return 'secondary'
          case COST_RECALC_RUN_STATUS.COMPUTED:
            return 'warning'
          case COST_RECALC_RUN_STATUS.APPLIED:
            return 'success'
          case COST_RECALC_RUN_STATUS.CANCELLED:
            return 'dark'
          default:
            return 'light'
        }
      },
      stepperItemClass(step) {
        const a = this.stepperActiveIndex
        if (!a) return 'is-upcoming'
        const st = this.runDetail && Number(this.runDetail.status)
        if (st === COST_RECALC_RUN_STATUS.APPLIED && step === 5 && a === 5) return 'is-done'
        if (step < a) return 'is-done'
        if (step === a) return 'is-current'
        return 'is-upcoming'
      },
      stepperShowsCheck(step) {
        const a = this.stepperActiveIndex
        if (!a || !this.runDetail) return false
        if (step < a) return true
        const st = Number(this.runDetail.status)
        if (st === COST_RECALC_RUN_STATUS.APPLIED && a === 5 && step === 5) return true
        return false
      },
      formatPeriodDate(s) {
        if (s == null || s === '') return ''
        const t = String(s).trim()
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(t)
        if (m) return `${m[3]}/${m[2]}/${m[1]}`
        return t
      },
      formatDateTimeDdMmYyHhMm(iso) {
        if (iso == null || iso === '') return ''
        let d
        if (iso instanceof Date) d = iso
        else d = new Date(iso)
        if (Number.isNaN(d.getTime())) return String(iso)
        const pad = (n) => String(n).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(
          d.getMinutes(),
        )}`
      },
      productCodeLine(it) {
        if (!it) return '—'
        if (it.productCode) return it.productCode
        if (it.sku) return it.sku
        if (it.productId != null) return `ID ${it.productId}`
        return '—'
      },
      productNameLine(it) {
        if (!it) return ''
        return it.productName || it.name || ''
      },
      clearLinesSearchDebounceTimer() {
        if (this.linesSearchDebounceId != null) {
          clearTimeout(this.linesSearchDebounceId)
          this.linesSearchDebounceId = null
        }
      },
      buildLinesApiParams() {
        const params = {}
        const q = String(this.linesFilters.search || '').trim()
        if (q) params.search = q
        const dim = this.linesFilters.inventoryDimension
        const dNum = Number(dim)
        if (
          dNum === COST_RECALC_INVENTORY_DIMENSION.PRODUCT ||
          dNum === COST_RECALC_INVENTORY_DIMENSION.IMEI
        ) {
          params.inventoryDimension = dNum
        }
        const limit = Number(this.linesLimit) || 100
        const page = Math.max(1, Number(this.linesPage) || 1)
        params.limit = limit
        params.offset = (page - 1) * limit
        return params
      },
      debouncedFetchLines() {
        if (!this.runDetail || !this.linesPreviewEligible) return
        this.clearLinesSearchDebounceTimer()
        this.linesSearchDebounceId = setTimeout(() => {
          this.linesSearchDebounceId = null
          this.linesPage = 1
          this.fetchLines(false)
        }, 450)
      },
      flushLinesSearchDebounce(showToast = false) {
        this.clearLinesSearchDebounceTimer()
        this.linesPage = 1
        return this.fetchLines(showToast)
      },
      onLinesDimensionFilterChange() {
        this.clearLinesSearchDebounceTimer()
        this.linesPage = 1
        if (this.runDetail && this.linesPreviewEligible) this.fetchLines(false)
      },
      onLinesPageChange(page) {
        this.linesPage = Math.max(1, Number(page) || 1)
        this.fetchLines(false)
      },
      onLinesLimitChange() {
        this.linesPage = 1
        if (this.runDetail && this.linesPreviewEligible) this.fetchLines(false)
      },
      clearLinesFiltersAndRefetch() {
        this.linesFilters.search = ''
        this.linesFilters.inventoryDimension = null
        this.flushLinesSearchDebounce(false)
      },
      async exportPreviewCsv() {
        if (!this.runDetail || !this.runDetail.id) return
        // Xuất TOÀN BỘ dòng (không chỉ trang hiện tại) — gọi API với all=1.
        this.linesExporting = true
        let exportRows = this.lines
        try {
          const params = {}
          const q = String(this.linesFilters.search || '').trim()
          if (q) params.search = q
          const dim = Number(this.linesFilters.inventoryDimension)
          if (
            dim === COST_RECALC_INVENTORY_DIMENSION.PRODUCT ||
            dim === COST_RECALC_INVENTORY_DIMENSION.IMEI
          ) {
            params.inventoryDimension = dim
          }
          params.all = 1
          const axiosRes = await getCostRecalculationLines(this.runDetail.id, params)
          const envelope = axiosRes.data
          if (this.isHttpEnvelopeOk(envelope, [200])) {
            const payload = envelope.data
            exportRows = Array.isArray(payload)
              ? payload
              : Array.isArray(payload && payload.items)
                ? payload.items
                : exportRows
          }
        } catch (e) {
          makeToastFaile('Không tải được toàn bộ dòng để xuất; xuất theo trang hiện tại.')
        } finally {
          this.linesExporting = false
        }
        this.buildAndDownloadCsv(exportRows)
      },
      buildAndDownloadCsv(sourceRows) {
        const headers = [
          'MaSP',
          'TenSP',
          'ChieuTon',
          'IMEI',
          'SL_Dau',
          'DGV_Dau',
          'NhapKy',
          'XuatKy',
          'DGV_Tinh',
          'SL_Cuoi',
          'DGV_Cuoi',
        ]
        const sep = ';'
        const dash = (v) => {
          if (v == null || v === '') return ''
          const n = Number(v)
          return Number.isFinite(n)
            ? String(n).replace(/\./g, ',')
            : String(v).replace(/\r?\n/g, ' ')
        }
        const rows = (sourceRows || []).map((r) =>
          [
            dash(this.productCodeLine(r)),
            dash(this.productNameLine(r)),
            dash(this.inventoryDimensionLabel(r.inventoryDimension)),
            dash(r.imeiNoSnapshot),
            dash(r.openingQty),
            dash(r.openingUnitCost),
            dash(r.periodReceiptQty),
            dash(r.periodIssueQty),
            dash(r.computedUnitCost),
            dash(r.closingQty),
            dash(r.closingUnitCost),
          ].join(sep),
        )
        const BOM = '\uFEFF'
        const body = `${headers.join(sep)}\r\n${rows.join('\r\n')}`
        const blob = new Blob([BOM + body], { type: 'text/csv;charset=utf-8' })
        const name = `cost-recalc-${(this.runDetail && this.compactRunId) || 'export'}.csv`
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
        URL.revokeObjectURL(url)
        makeToastSuccess('Đã xuất file CSV.')
      },
      async copyRunId() {
        const id = this.runDetail && this.runDetail.id
        if (!id) return
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(id)
            makeToastSuccess('Đã copy UUID.')
            return
          }
        } catch (_) {
          /* fallback */
        }
        try {
          const ta = document.createElement('textarea')
          ta.value = id
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
          makeToastSuccess('Đã copy UUID.')
        } catch (_) {
          makeToastFaile('Không copy được UUID.')
        }
      },
      async fetchRunsList(resetPage = false) {
        if (!this.checkPermission('COST_RECALCULATION_VIEW')) {
          this.runsList = []
          this.runsListTotal = 0
          return
        }
        if (!Number(this.form.companyId)) {
          this.runsList = []
          this.runsListTotal = 0
          return
        }
        if (resetPage) this.runsListPage = 1
        const limit = this.runsListLimitClamped
        const offset = (this.runsListPage - 1) * limit
        this.runsListLoading = true
        try {
          const params = {
            companyId: Number(this.form.companyId),
            limit,
            offset,
          }
          if (this.runsListFilters.status != null && this.runsListFilters.status !== '') {
            params.status = Number(this.runsListFilters.status)
          }
          const axiosRes = await listCostRecalculationRuns(params)
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope, 'Không tải được danh sách lô'))
            this.runsList = []
            this.runsListTotal = 0
            return
          }
          const body = envelope.data && typeof envelope.data === 'object' ? envelope.data : {}
          this.runsList = Array.isArray(body.items) ? body.items : []
          this.runsListTotal = Number(body.total) || 0
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
          this.runsList = []
          this.runsListTotal = 0
        } finally {
          this.runsListLoading = false
        }
      },
      openRunFromList(item) {
        const id = this.resolveRunListItemId(item)
        if (!id) {
          makeToastFaile('Không xác định được id lô.')
          return
        }
        this.manualRunId = id
        this.refreshRunQuiet(id)
      },
      resolveRunListItemId(item) {
        if (!item) return ''
        const id = item.id != null ? item.id : item.runId
        return id != null ? String(id).trim() : ''
      },
      compactRunIdHint(id) {
        const s = id != null ? String(id) : ''
        if (s.length <= 22) return s
        return `${s.slice(0, 8)}…${s.slice(-6)}`
      },
      async bootstrapOrg() {
        try {
          const cid = parseInt(getData('currentCompanyId'), 10)
          const { data: body } = await ApiService.get('/v1/companies/all')
          this.companies = body.data || []
          if (!this.form.companyId && Number.isFinite(cid) && cid > 0) {
            const ok = this.companies.some((c) => Number(c.id) === cid)
            this.form.companyId = ok
              ? cid
              : this.companies.length
                ? Number(this.companies[0].id)
                : null
          }
        } catch (_) {
          makeToastFaile('Không tải được danh sách công ty')
        }
      },
      extractEnvelopeMessage(envelope, fallback = 'Thao tác thất bại') {
        return (envelope && (envelope.message || envelope.Message)) || fallback
      },
      isHttpEnvelopeOk(envelope, allow = [200, 201, 202]) {
        const s = Number(envelope && envelope.status)
        return allow.includes(s)
      },
      async createRun() {
        this.createFormShowErrors = true
        if (!this.canCreate) {
          makeToastFaile('Vui lòng điền đủ: công ty, phương pháp và kỳ (đến ≥ từ).')
          return
        }
        this.busy = true
        this.processHint = ''
        try {
          const payload = {
            companyId: Number(this.form.companyId),
            periodStart: this.form.periodStart,
            periodEnd: this.form.periodEnd,
            valuationMethod: Number(this.form.valuationMethod) || 1,
          }
          if (this.form.memo) payload.memo = this.form.memo
          const axiosRes = await createCostRecalculationRun(payload)
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200, 201])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope))
            return
          }
          const run = envelope.data
          if (!run || !run.id) {
            makeToastFaile('Không nhận được id lô từ máy chủ.')
            return
          }
          this.runDetail = run
          this.manualRunId = run.id
          this.lines = []
          this.createFormShowErrors = false
          this.runFetchedAt = new Date()
          makeToastSuccess('Đã tạo lô.')
          this.fetchRunsList(true)
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
        } finally {
          this.busy = false
        }
      },
      async loadManualRun() {
        const id = (this.manualRunId || '').trim()
        if (!id) {
          makeToastFaile('Nhập UUID lô.')
          return
        }
        this.abortPoll = true
        try {
          await this.refreshRunQuiet(id)
        } finally {
          this.abortPoll = false
        }
      },
      async refreshRunQuiet(id) {
        const runId = (id || (this.runDetail && this.runDetail.id) || this.manualRunId || '').trim()
        if (!runId) return null
        this.busy = true
        try {
          const axiosRes = await getCostRecalculationRun(runId)
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope, 'Không đọc được lô'))
            return null
          }
          const run = envelope.data
          const prevId =
            this.runDetail && this.runDetail.id != null ? String(this.runDetail.id) : ''
          const nextId = run && run.id != null ? String(run.id) : String(runId).trim()
          this.runDetail = run
          if (prevId !== nextId) {
            this.linesFilters.search = ''
            this.linesFilters.inventoryDimension = null
            this.linesPage = 1
            this.clearLinesSearchDebounceTimer()
          }
          this.manualRunId = run.id || runId
          this.runFetchedAt = new Date()
          if (Number(run.status) === COST_RECALC_RUN_STATUS.COMPUTED) {
            await this.fetchLines(false)
          } else if (Number(run.status) === COST_RECALC_RUN_STATUS.APPLIED) {
            await this.fetchLines(false)
          } else {
            this.lines = []
            this.linesTotal = 0
            this.linesSummary = null
          }
          return run
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
          return null
        } finally {
          this.busy = false
        }
      },
      async fetchLines(showToast = false) {
        if (!this.runDetail || !this.runDetail.id) return
        if (!this.linesPreviewEligible) return
        if (!this.checkPermission('COST_RECALCULATION_VIEW')) return
        this.linesLoading = true
        try {
          const axiosRes = await getCostRecalculationLines(
            this.runDetail.id,
            this.buildLinesApiParams(),
          )
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope, 'Không tải được dòng'))
            return
          }
          const payload = envelope.data
          if (Array.isArray(payload)) {
            // Tương thích ngược: backend cũ trả mảng thuần (không phân trang)
            this.lines = payload
            this.linesTotal = payload.length
            this.linesSummary = null
          } else {
            const data = payload && typeof payload === 'object' ? payload : {}
            this.lines = Array.isArray(data.items)
              ? data.items
              : Array.isArray(data.data)
                ? data.data
                : []
            this.linesTotal = Number(data.total) || this.lines.length
            this.linesSummary =
              data.summary && typeof data.summary === 'object' ? data.summary : null
          }
          if (showToast) makeToastSuccess('Đã cập nhật dòng preview.')
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
        } finally {
          this.linesLoading = false
        }
      },
      async runPollAfterQueued(runId, untilStatuses, hint) {
        const defaultHint =
          'Đang chờ worker… (đang poll chi tiết lô; có thể đóng trang và mở lại bằng UUID).'
        this.processHint = hint != null && hint !== '' ? hint : defaultHint
        this.abortPoll = false
        try {
          await pollCostRecalculationRun(
            runId,
            (run) => untilStatuses.includes(Number(run.status)),
            {
              intervalMs: 3500,
              maxAttempts: 180,
              isCancelled: () => this.abortPoll,
            },
          )
        } catch (err) {
          if (!this.abortPoll && err && err.message !== 'Đã dừng chờ') {
            makeToastFaile(err.message || 'Hết thời gian chờ')
          }
        } finally {
          this.processHint = ''
          await this.refreshRunQuiet(runId)
        }
      },
      async onCompute() {
        if (!this.canComputeRun) return
        const runId = this.runDetail.id
        this.abortPoll = false
        this.pollingRecompute = false
        this.pollingCompute = true
        try {
          const axiosRes = await computeCostRecalculationRun(runId, {})
          const httpStatus = axiosRes.status
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200, 202])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope))
            return
          }
          const d = envelope.data || {}
          if (httpStatus === 202 || d.queued) {
            await this.runPollAfterQueued(
              runId,
              [COST_RECALC_RUN_STATUS.COMPUTED, COST_RECALC_RUN_STATUS.APPLIED],
              '',
            )
            await this.fetchLines(false)
            makeToastSuccess('Đã tính xong (worker).')
          } else {
            await this.refreshRunQuiet(runId)
            makeToastSuccess('Đã tính xong.')
          }
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
        } finally {
          this.pollingCompute = false
          this.pollingRecompute = false
        }
      },
      async onRecompute() {
        if (!this.canRecomputeRun) return
        const runId = this.runDetail.id
        this.abortPoll = false
        this.pollingRecompute = true
        this.pollingCompute = true
        this.lines = []
        this.linesTotal = 0
        this.linesSummary = null
        this.linesPage = 1
        try {
          const axiosRes = await recomputeCostRecalculationRun(runId, {})
          const httpStatus = axiosRes.status
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200, 202])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope))
            return
          }
          const d = envelope.data || {}
          if (httpStatus === 202 || d.queued) {
            await this.runPollAfterQueued(
              runId,
              [COST_RECALC_RUN_STATUS.COMPUTED, COST_RECALC_RUN_STATUS.APPLIED],
              '',
            )
            await this.fetchLines(false)
            makeToastSuccess('Đã tính lại (worker).')
          } else {
            await this.refreshRunQuiet(runId)
            makeToastSuccess('Đã tính lại.')
          }
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
        } finally {
          this.pollingCompute = false
          this.pollingRecompute = false
        }
      },
      async onApply() {
        if (!this.canApplyRun) return
        const runId = this.runDetail.id
        this.abortPoll = false
        this.pollingApply = true
        try {
          const idempotencyKey =
            typeof crypto !== 'undefined' && crypto.randomUUID
              ? `fe-${crypto.randomUUID()}`.slice(0, 64)
              : undefined
          const axiosRes = await applyCostRecalculationRun(
            runId,
            idempotencyKey ? { idempotencyKey } : {},
          )
          const httpStatus = axiosRes.status
          const envelope = axiosRes.data
          if (!this.isHttpEnvelopeOk(envelope, [200, 202])) {
            makeToastFaile(this.extractEnvelopeMessage(envelope))
            return
          }
          const d = envelope.data || {}
          if (httpStatus === 202 || d.queued) {
            await this.runPollAfterQueued(runId, [COST_RECALC_RUN_STATUS.APPLIED], '')
            makeToastSuccess('Đã áp dụng (worker).')
          } else {
            makeToastSuccess(
              `Đã áp dụng${typeof d.appliedCount === 'number' ? `: ${d.appliedCount} dòng` : ''}.`,
            )
            await this.refreshRunQuiet(runId)
          }
        } catch (e) {
          const msg =
            this.extractEnvelopeMessage(
              e && e.response && e.response.data,
              e.message || 'Lỗi mạng',
            ) || 'Lỗi'
          makeToastFaile(msg)
        } finally {
          this.pollingApply = false
        }
      },
      resetWorkflow() {
        this.abortPoll = true
        this.clearLinesSearchDebounceTimer()
        this.pollingCompute = false
        this.pollingRecompute = false
        this.runDetail = null
        this.lines = []
        this.linesTotal = 0
        this.linesSummary = null
        this.linesPage = 1
        this.linesFilters.search = ''
        this.linesFilters.inventoryDimension = null
        this.manualRunId = ''
        this.processHint = ''
        this.createFormShowErrors = false
        this.runFetchedAt = null
        this.collapseMetaOpen = false
        if (this.checkPermission('COST_RECALCULATION_VIEW') && Number(this.form.companyId)) {
          this.fetchRunsList(true)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .inventory-cost-recalc-page {
  .ccr-head-title {
    .ccr-short-id {
      font-size: 0.92rem;
      color: #464e5f;
      background: #f3f6f9;
      padding: 0.12rem 0.45rem;
      border-radius: 0.28rem;
    }

    .ccr-status-pill {
      font-weight: 600;
      letter-spacing: 0.02em;
    }
  }

  .min-w-0 {
    min-width: 0;
  }

  .ccr-workspace {
    border-color: #e4e6ef !important;
  }

  .ccr-toolbar {
    border-color: #eff2f5 !important;
    gap: 0.25rem;
  }

  .ccr-tool-btn {
    font-weight: 600;
    border-radius: 0.35rem;
  }

  .ccr-stepper-item {
    flex: 1 1 0;
    min-width: 4.5rem;
    max-width: 9rem;
  }

  .ccr-stepper-circle {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
    border: 2px solid #e4e6ef;
    background: #fff;
    color: #7e8299;
    transition: border-color 0.15s ease, background 0.15s ease;
  }

  .ccr-stepper-label {
    font-weight: 600;
    color: #7e8299;
    line-height: 1.25;
  }

  .ccr-stepper-item.is-done .ccr-stepper-circle {
    border-color: #1bc5bd;
    background: #e8fff9;
    color: #1bc5bd;
    font-size: 0.72rem;
  }

  .ccr-stepper-item.is-done .ccr-stepper-label {
    color: #3f4254;
  }

  .ccr-stepper-item.is-current .ccr-stepper-circle {
    border-color: #ffa800;
    background: #fff8dd;
    color: #d97706;
    box-shadow: 0 0 0 2px rgba(255, 168, 0, 0.2);
  }

  .ccr-stepper-item.is-current .ccr-stepper-label {
    color: #d97706;
    font-weight: 700;
  }

  .ccr-kpi-card {
    border-color: #eef0f8 !important;
    background: #fafbfc;
  }

  .ccr-kpi-k {
    letter-spacing: 0.04em;
    font-weight: 700;
    font-size: 0.65rem;
  }

  .ccr-thumb {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #ebedf3;
    background: linear-gradient(145deg, #f5f8fa, #ebedf3);
  }

  .ccr-table-card-head {
    align-items: center;
  }

  .ccr-lead {
    line-height: 1.45;
  }

  .ccr-kicker {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 600;
    color: #7e8299;
    white-space: nowrap;
  }

  .ccr-workflow {
    border-color: #e4e6ef !important;
  }

  .ccr-workflow-line {
    line-height: 1.5;
  }

  .ccr-step-sep {
    display: inline-block;
    padding: 0 0.4rem;
    font-weight: 600;
  }

  .ccr-code {
    font-size: 0.8em;
    padding: 0.1rem 0.25rem;
    background: #f3f6f9;
    border-radius: 0.2rem;
  }

  .ccr-card {
    border-color: #e4e6ef;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02);
  }

  .ccr-card-header {
    font-weight: 600;
    font-size: 0.9rem;
    letter-spacing: 0.01em;
  }

  .ccr-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #464e5f;
    margin-bottom: 0.25rem;
  }

  .ccr-form-actions {
    border-color: #eff2f5 !important;
  }

  .ccr-uuid-group {
    max-width: 52rem;
  }

  .ccr-run-id {
    max-width: 100%;
    text-align: right;
  }

  @media (min-width: 768px) {
    .ccr-run-id {
      max-width: 42%;
    }
  }

  .ccr-dl {
    dt {
      font-weight: 600;
      color: #7e8299;
    }

    dd {
      margin-bottom: 0.35rem;
    }
  }

  .ccr-table-wrap {
    max-height: min(70vh, 560px);
    overflow: auto;
  }

  ::v-deep .select-style {
    width: 100%;
  }

  .ccr-lines-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem 1rem;
    padding: 16px 0 4px;
  }

  .ccr-lines-toolbar__left {
    display: flex;
    align-items: center;
  }

  .ccr-lines-toolbar__total {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
  }

  .ccr-lines-toolbar__total-label {
    font-size: 13px;
    font-weight: 450;
    color: #64748b;
  }

  .ccr-lines-toolbar__total-value {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    font-variant-numeric: tabular-nums;
  }

  .ccr-lines-toolbar__right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .ccr-lines-toolbar__divider {
    width: 1px;
    height: 20px;
    background: #e2e8f0;
  }

  ::v-deep .ccr-lines-pagination {
    margin-bottom: 0 !important;
  }

  ::v-deep .ccr-lines-pagination .page-link {
    border-radius: 6px !important;
  }

  ::v-deep tr.ccr-tr-imei-child td {
    background-color: #f9fafc;
  }

  ::v-deep tr.ccr-tr-imei-child td:first-child {
    padding-left: 1.5rem !important;
  }

  ::v-deep .cost-recalc-lines-table {
    font-size: 12px;
  }

  ::v-deep .cost-recalc-lines-table th.ccr-col-highlight,
  ::v-deep .cost-recalc-lines-table td.ccr-col-highlight {
    background-color: #fff9e0 !important;
  }
}
</style>

